<template>
  <div class="articles-slider-container">
    <v-sheet
      max-width="1344"
      min-width="0"
      class="mx-auto articles-sheet"
      v-if="articles.length"
    >
      <v-slide-group show-arrows class="articles-slider">
        <v-slide-item v-for="a in articles" :key="a.id">
          <PdfItem
            :articleId="a.id"
            :articleTitle="a.title"
            :searchTexts="searchTexts"
            :originalId="a.original"
            :isOpenAccess="a.open"
          />
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
    <div v-else-if="isSearch" class="text-center">
      {{ $t('search.noArticles') }}
    </div>
    <div v-else class="text-center">
      {{ $t('common.noArticles') }}
    </div>
  </div>
</template>

<script>
import PdfItem from '@/components/PdfItem'

export default {
  props: {
    articles: Array,
    searchTexts: Array
  },
  data() {
    return { isSearch: false }
  },
  created() {
    if (this.$route.meta.isSearch) {
      this.isSearch = true
    }
  },
  components: {
    PdfItem
  }
}
</script>

<style lang="scss">
.articles-slider-container {
  padding: 0 10px;

  .articles-sheet {
    margin: auto;

    .articles-slider {
      .v-slide-group__wrapper {
        padding: 10px 0;
      }
      .v-slide-group__content {
        justify-content: center;
      }
      .v-slide-group__next,
      .v-slide-group__prev {
        background: #165dad;
        margin: 9px 0;
        border-radius: 4px;
        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
          0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);

        .v-icon {
          color: white;
        }
        &--disabled {
          opacity: 0;
        }
      }
    }
  }
}
</style>
